import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import GeneralStoreSelect from "components/DropDowns/GeneralStoreSelect";

import { useTranslation } from "react-i18next";

function CategoryExtraPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/extra-categories";
  const history = useHistory();
  const { id } = useParams();
  const [storeId, setStoreId] = useState(null);
  const [extraCategoryName, setExtraCategoryName] = useState("");
  const [extraCategoryOrder, setExtraCategoryOrder] = useState(0);
  const [extraCategorySingleChoice, setExtraCategorySingleChoice] = useState(false);
  const [extraCategoryDeleted, setExtraCategoryDeleted] = useState(false);
  const [extraCategoryMandatory, setExtraCategoryMandatory] = useState(false);
  const [extraCategoryColor, setExtraCategoryColor] = useState("#28c76f");

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleStoreId = (id) => {
    setStoreId(id);
  };

  const handleScroll = (e) => {
    e.target.blur();
  };

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/extra-categories/${id}`)
      .then((extraCategory) => {
        fillFields(extraCategory);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const save = () => {
    setIsDisabled(true);
    const extraCategory = {
      name: extraCategoryName,
      order: extraCategoryOrder ? extraCategoryOrder : 0,
      color: extraCategoryColor ? extraCategoryColor : "ffffff",
      storeId: storeId,
      singleChoice: extraCategorySingleChoice,
      deleted: extraCategoryDeleted,
      mandatorySelection: extraCategoryMandatory,
    };

    if (id) {
      apiService
        .putJson(`api/v1/extra-categories/${id}`, extraCategory)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.extraCategorySavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/extra-categories", extraCategory)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.extraCategoryCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (extraCategory) => {
    setExtraCategoryName(extraCategory.name);
    setExtraCategoryOrder(extraCategory.order);
    setExtraCategoryColor(extraCategory.color);
    setExtraCategorySingleChoice(extraCategory.singleChoice);
    setExtraCategoryDeleted(extraCategory.deleted);
    setExtraCategoryMandatory(extraCategory.mandatorySelection);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editExtraCategory") : t("pages.titles.createExtraCategory")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.designation")}</label>
                        <Form.Control
                          placeholder={t("common.labels.designation")}
                          required={true}
                          type="text"
                          value={extraCategoryName}
                          onChange={(event) => setExtraCategoryName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.order")}</label>
                        <Form.Control
                          placeholder={t("common.labels.order")}
                          required={true}
                          type="number"
                          value={extraCategoryOrder}
                          onChange={(event) => setExtraCategoryOrder(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.color")}</label>
                        <Form.Control
                          placeholder={t("common.labels.color")}
                          required={true}
                          type="color"
                          value={extraCategoryColor}
                          onChange={(event) => setExtraCategoryColor(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <GeneralStoreSelect title={t("common.labels.store")} disabled={true} selectedStoreId={handleStoreId} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="2">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-1"
                            checked={extraCategorySingleChoice}
                            onChange={(e) => setExtraCategorySingleChoice(e.target.checked)}
                          />
                          <span className="ml-1">{t("common.labels.singleChoice")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="2">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-3"
                            checked={extraCategoryMandatory}
                            onChange={(e) => setExtraCategoryMandatory(e.target.checked)}
                          />
                          <span className="ml-1">{t("messages.requiredSelection")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="1">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-2"
                            checked={extraCategoryDeleted}
                            onChange={(e) => setExtraCategoryDeleted(e.target.checked)}
                          />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CategoryExtraPage;
